import AllocationIcon from './allocation.svg';

export { AllocationIcon };
